import { Paper, Stack, Box, Typography } from "@mui/material";
import Carousel from "components/sitelet/input-page/files-card/carousel";
import FilesList from "components/sitelet/input-page/files-card/files-list";
import { useEasierTheme } from "datalign-themes";
import Asset from "datalign-module-template/models/asset";
import React from "react";

const FilesCard = ({ type, assets }: { type: string; assets: Asset[] }) => {
  const easierTheme = useEasierTheme();

  return (
    <Paper sx={{ mt: 2 }}>
      <Stack>
        <Box
          sx={{
            display: "flex",
            p: 2,

            ...(["FAF-nt", "nrdata-orig"].includes(
              process.env.REACT_APP_STYLING_THEME ?? "",
            )
              ? {
                  background: "#E35205",
                }
              : {
                  background: easierTheme?.Colour.Secondary(),
                  borderRadius: "8px 8px 0px 0px",
                }),
          }}
        >
          <Typography
            variant="h3"
            sx={{
              m: "auto auto auto 0px",
              ...(["FAF-nt", "nrdata-orig"].includes(
                process.env.REACT_APP_STYLING_THEME ?? "",
              )
                ? {
                    lineHeight: 1.6,
                    letterSpacing: 0.3,
                    fontSize: "0.9rem",
                    fontWeight: 450,
                    color: easierTheme?.Colour.OnSecondary(),
                  }
                : { color: easierTheme?.Colour.OnPrimary() }),
            }}
          >
            {type} files
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <Carousel assets={assets} />
          <FilesList assets={assets} />
        </Box>
      </Stack>
    </Paper>
  );
};

export default FilesCard;
